(() => {
  const init = () => {
    document.querySelectorAll('[data-ge-page-content]').forEach(content => {
      if (content.dataset.geReady) return;
      content.dataset.geReady = 'true';
      const headings = [...content.querySelectorAll('h2,h3')].filter(h => h.textContent.trim());
      if (headings.length < 3) return;
      const nav = document.createElement('nav');
      nav.className = 'ge-page-nav';
      nav.setAttribute('aria-label', content.dataset.geContentsLabel);
      headings.forEach((heading, i) => {
        if (!heading.id) heading.id = 'ge-page-topic-' + i;
        const link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent;
        nav.append(link);
      });
      content.prepend(nav);
    });
  };
  const start = () => init();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', init);
})();

